module.exports = __webpack_public_path__ + "static/hyperv_10.fe939ca2.jpg";